import axiosInstance from './axiosInstance';

const getClientPaycloudStepperData = (clientId) =>
  axiosInstance.get(`/internal/admin/clients/${clientId}/paycloud/stepper`);

export default getClientPaycloudStepperData;
